import React from 'react'
import { Box, Switch, Typography } from '@mui/material'
import clsx from 'clsx'
import useStyles from './_styles'
import { LargeSwitchProps } from './_props'

const LargeSwitch = ({ label, labelPosition = 'end', disabled, error, ...switchProps }: LargeSwitchProps) => {
    const classes = useStyles()

    const endPosition = labelPosition === 'end' && label
    const startPosition = labelPosition === 'start' && label

    const labelComponent = React.useMemo(
        () => <Typography className={classes.LargeSwitchLabel}>{label}</Typography>,
        [classes.LargeSwitchLabel, label],
    )

    return (
        <Box className={classes.LargeSwitchWrapper}>
            {startPosition && labelComponent}
            <Switch
                className={classes.LargeSwitch}
                disabled={disabled}
                classes={{
                    switchBase: clsx(
                        classes.LargeSwitchBase,
                        error && classes.LargeSwitchBaseError,
                        disabled && classes.LargeSwitchBaseDisabled,
                    ),
                    thumb: clsx(
                        classes.LargeSwitchThumb,
                        disabled && classes.LargeSwitchThumbDisabled,
                        'LargeSwitchThumb',
                    ),
                    track: clsx(classes.LargeSwitchTrack, disabled && classes.LargeSwitchTrackDisabled),
                }}
                {...switchProps}
            />
            {endPosition && labelComponent}
        </Box>
    )
}

export default LargeSwitch
